import { render } from "./index.vue?vue&type=template&id=bf439f68&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bf439f68&scoped=true&lang=less"

import exportComponent from "F:\\project\\trade_lab_frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf439f68"]])

export default __exports__